var _circle, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMobileProfileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 38,
    viewBox: "0 0 35 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_19371_2458",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 25,
    height: 25
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 12.5,
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_19371_2458)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.5C25.7843 2.5 32.5 9.21573 32.5 17.5C32.5 25.7843 25.7843 32.5 17.5 32.5C9.21573 32.5 2.5 25.7843 2.5 17.5C2.5 9.21573 9.21573 2.5 17.5 2.5Z",
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.04297,
    y: 21.7063,
    width: 16.9128,
    height: 15.4645,
    rx: 7.73223,
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 13.3203,
    y: 10.4434,
    width: 8.35836,
    height: 9.38637,
    rx: 4.17918,
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMobileProfileIcon);
export default __webpack_public_path__ + "static/media/MobileProfileIcon.0d76b8c25116ac363826926ed82a6ac6.svg";
export { ForwardRef as ReactComponent };